import { useEffect } from "react";

const useKeyboardShortcuts = (handlers) => {
    useEffect(() => {
        const handleKeyDown = (event) => {
            // Ignore if user is typing in an input
            if (
                event.target.tagName === "INPUT" ||
                event.target.tagName === "TEXTAREA" ||
                event.target.isContentEditable
            ) {
                // Allow Esc and Ctrl+Enter even in inputs
                if (event.key !== "Escape" && !(event.ctrlKey && event.key === "Enter")) {
                    return;
                }
            }

            const { key, ctrlKey, metaKey, shiftKey } = event;
            const modKey = ctrlKey || metaKey;

            // N - New task
            if (key === "n" && !modKey && !shiftKey && handlers.onNew) {
                event.preventDefault();
                handlers.onNew();
            }

            // F - Focus search
            if (key === "f" && !modKey && !shiftKey && handlers.onFocusSearch) {
                event.preventDefault();
                handlers.onFocusSearch();
            }

            // Esc - Close modals
            if (key === "Escape" && handlers.onEscape) {
                event.preventDefault();
                handlers.onEscape();
            }

            // Ctrl+Enter - Save
            if (key === "Enter" && modKey && handlers.onSave) {
                event.preventDefault();
                handlers.onSave();
            }

            // Delete - Delete selected
            if (key === "Delete" && handlers.onDelete) {
                event.preventDefault();
                handlers.onDelete();
            }

            // E - Edit selected
            if (key === "e" && !modKey && !shiftKey && handlers.onEdit) {
                event.preventDefault();
                handlers.onEdit();
            }

            // ? - Show shortcuts help
            if (key === "?" && handlers.onHelp) {
                event.preventDefault();
                handlers.onHelp();
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [handlers]);
};

export default useKeyboardShortcuts;
